/*
 * Jaluse linkiveerud akordioniks — ainult mobiilis.
 *
 * MIKS. Jalus oli 375×812 vaateaknas mõõdetult 1382px ehk 1,70 ekraanitäit —
 * 54% kogu /collections/seerumid lehe pikkusest. Sellest 807px oli linkide
 * ruudustik: bränd 217px + kolm veergu (182/182/143), igaüks omal real.
 * Kokkuklapitult jääb kolmest veerust ~150px.
 *
 * MIKS VASTUPIDI KUI `legal-page.js`. Sisukord renderdub suletuna ja JS avab
 * ta lauaarvutil; siin renderdub veerg LAHTI ja JS sulgeb ta mobiilis. Vahe on
 * taandarengus: kui see fail ei jõua kohale, jääb jalus täpselt selliseks,
 * nagu ta täna on — kõik lingid nähtaval, kõigil ekraanidel. Vastupidise
 * mustri korral kaoks JS-ita jaluse navigatsioon ka lauaarvutil.
 *
 * `<details>` on siin `open` atribuudiga HTML-is, seega vilkumist mobiilis
 * enne skripti käivitumist praktikas ei näe: jalus on lehe kõige alumine plokk
 * ja see kokkuklapp toimub kaugel allpool vaateakent.
 */
(function () {
  const BREAKPOINT = '(max-width: 749px)';

  function init() {
    const columns = document.querySelectorAll('.footer-taramar__column--links');
    if (!columns.length || !window.matchMedia) return;

    const mobile = window.matchMedia(BREAKPOINT);

    /*
     * Kasutaja enda klõps peab võitma. Kui ta on veeru mobiilis lahti teinud,
     * ei tohi järgmine `change` sündmus (nt ekraani pööramine) seda kinni
     * lüüa — seepärast märgime puudutatud veeru ära ja jätame ta rahule.
     */
    columns.forEach((column) => {
      column.addEventListener('toggle', () => {
        if (mobile.matches) column.dataset.userToggled = 'true';
      });
    });

    const sync = (event) => {
      columns.forEach((column) => {
        if (event.matches) {
          if (column.dataset.userToggled !== 'true') column.open = false;
        } else {
          column.open = true;
          delete column.dataset.userToggled;
        }
      });
    };

    sync(mobile);
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    else if (mobile.addListener) mobile.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
